{
  "about.blocks": "Moderirani strežniki",
  "about.contact": "Stik:",
  "about.default_locale": "Privzeto",
  "about.disclaimer": "Mastodon je prosto, odprtokodno programje in blagovna znamka podjetja Mastodon gGmbH.",
  "about.domain_blocks.no_reason_available": "Razlog ni na voljo",
  "about.domain_blocks.preamble": "Mastodon vam na splošno omogoča ogled vsebin in interakcijo z uporabniki z vseh drugih strežnikov v fediverzumu. Tu so navedene izjeme, ki jih postavlja ta strežnik.",
  "about.domain_blocks.silenced.explanation": "V splošnem ne boste videli profilov in vsebin s tega strežnika, razen če jih izrecno poiščete ali jim začnete slediti.",
  "about.domain_blocks.silenced.title": "Omejeno",
  "about.domain_blocks.suspended.explanation": "Nobeni podatki s tega strežnika ne bodo obdelani, shranjeni ali izmenjani, zaradi česar je nemogoča kakršna koli interakcija ali komunikacija z uporabniki s tega strežnika.",
  "about.domain_blocks.suspended.title": "Suspendiran",
  "about.language_label": "Jezik",
  "about.not_available": "Ti podatki še niso na voljo na tem strežniku.",
  "about.powered_by": "Decentraliziran družabni medij, ki ga poganja {mastodon}",
  "about.rules": "Pravila strežnika",
  "account.account_note_header": "Zasebna opomba",
  "account.add_or_remove_from_list": "Dodaj ali odstrani s seznamov",
  "account.badges.bot": "Robot",
  "account.badges.group": "Skupina",
  "account.block": "Blokiraj @{name}",
  "account.block_domain": "Blokiraj domeno {domain}",
  "account.block_short": "Blokiraj",
  "account.blocked": "Blokirano",
  "account.cancel_follow_request": "Umakni zahtevo za sledenje",
  "account.copy": "Kopiraj povezavo do profila",
  "account.direct": "Zasebno omeni @{name}",
  "account.disable_notifications": "Ne obveščaj me več, ko ima @{name} novo objavo",
  "account.edit_profile": "Uredi profil",
  "account.edit_profile_short": "Uredi",
  "account.enable_notifications": "Obvesti me, ko ima @{name} novo objavo",
  "account.endorse": "Izpostavi v profilu",
  "account.familiar_followers_one": "Sledi {name1}",
  "account.featured": "Izpostavljeni",
  "account.featured.accounts": "Profili",
  "account.follow": "Sledi",
  "account.follow_back": "Sledi nazaj",
  "account.follow_back_short": "Sledi nazaj",
  "account.follow_request": "Zaprosi za sledenje",
  "account.follow_request_cancel": "Prekliči zahtevo",
  "account.follow_request_cancel_short": "Prekliči",
  "account.follow_request_short": "Zaprosi",
  "account.followers": "Sledilci",
  "account.followers.empty": "Nihče še ne sledi temu uporabniku.",
  "account.followers_counter": "{count, plural, one {{counter} sledilec} two {{counter} sledilca} few {{counter} sledilci} other {{counter} sledilcev}}",
  "account.followers_you_know_counter": "{counter} znanih",
  "account.following": "Sledim",
  "account.following_counter": "{count, plural, one {{counter} sleden} two {{counter} sledena} few {{counter} sledeni} other {{counter} sledenih}}",
  "account.follows.empty": "Ta uporabnik še ne sledi nikomur.",
  "account.follows_you": "Vam sledi",
  "account.go_to_profile": "Pojdi na profil",
  "account.hide_reblogs": "Skrij izpostavitve od @{name}",
  "account.in_memoriam": "V spomin.",
  "account.joined_short": "Pridružil/a",
  "account.languages": "Spremeni naročene jezike",
  "account.link_verified_on": "Lastništvo te povezave je bilo preverjeno {date}",
  "account.locked_info": "Stanje zasebnosti računa je nastavljeno na zaklenjeno. Lastnik ročno pregleda, kdo ga lahko spremlja.",
  "account.media": "Predstavnosti",
  "account.mention": "Omeni @{name}",
  "account.moved_to": "{name} sporoča, da ima zdaj nov račun:",
  "account.mute": "Utišaj @{name}",
  "account.mute_notifications_short": "Utišaj obvestila",
  "account.mute_short": "Utišaj",
  "account.muted": "Utišan",
  "account.mutual": "Drug drugemu sledita",
  "account.no_bio": "Ni opisa.",
  "account.open_original_page": "Odpri izvirno stran",
  "account.posts": "Objave",
  "account.remove_from_followers": "Odstrani {name} iz sledilcev",
  "account.report": "Prijavi @{name}",
  "account.requested_follow": "{name} vam želi slediti",
  "account.share": "Deli profil osebe @{name}",
  "account.show_reblogs": "Pokaži izpostavitve osebe @{name}",
  "account.statuses_counter": "{count, plural, one {{counter} objava} two {{counter} objavi} few {{counter} objave} other {{counter} objav}}",
  "account.unblock": "Odblokiraj @{name}",
  "account.unblock_domain": "Odblokiraj domeno {domain}",
  "account.unblock_domain_short": "Odblokiraj",
  "account.unblock_short": "Odblokiraj",
  "account.unendorse": "Ne vključi v profil",
  "account.unfollow": "Ne sledi več",
  "account.unmute": "Povrni glas @{name}",
  "account.unmute_notifications_short": "Izklopi utišanje obvestil",
  "account.unmute_short": "Povrni glas",
  "account_note.placeholder": "Kliknite, da dodate opombo",
  "admin.dashboard.daily_retention": "Mera ohranjanja uporabnikov po dnevih od registracije",
  "admin.dashboard.monthly_retention": "Mera ohranjanja uporabnikov po mesecih od registracije",
  "admin.dashboard.retention.average": "Povprečje",
  "admin.dashboard.retention.cohort": "Mesec registracije",
  "admin.dashboard.retention.cohort_size": "Novi uporabniki",
  "admin.impact_report.instance_accounts": "Profili računov, ki bi jih s tem izbrisali",
  "admin.impact_report.instance_followers": "Sledilci, ki bi jih izgubili naši uporabniki",
  "admin.impact_report.instance_follows": "Sledilci, ki bi jih izgubili njihovi uporabniki",
  "admin.impact_report.title": "Povzetek učinka",
  "alert.rate_limited.message": "Poskusite znova čez {retry_time, time, medium}.",
  "alert.rate_limited.title": "Hitrost omejena",
  "alert.unexpected.message": "Zgodila se je nepričakovana napaka.",
  "alert.unexpected.title": "Ojoj!",
  "alt_text_badge.title": "Nadomestno besedilo",
  "alt_text_modal.add_alt_text": "Dodaj nadomestno besedilo",
  "alt_text_modal.add_text_from_image": "Dodaj besedilo iz slike",
  "alt_text_modal.cancel": "Prekliči",
  "alt_text_modal.change_thumbnail": "Spremeni sličico",
  "alt_text_modal.describe_for_people_with_hearing_impairments": "Podaj opis za ljudi s težavami s sluhom ...",
  "alt_text_modal.describe_for_people_with_visual_impairments": "Podaj opis za slabovidne ...",
  "alt_text_modal.done": "Opravljeno",
  "announcement.announcement": "Oznanilo",
  "annual_report.announcement.action_dismiss": "Ne, hvala",
  "annual_report.nav_item.badge": "Nov",
  "annual_report.shared_page.donate": "Prispevaj",
  "annual_report.shared_page.footer": "S {heart} ustvarila ekipa Mastodon",
  "annual_report.summary.archetype.booster.name": "Lokostrelec",
  "annual_report.summary.archetype.die_drei_fragezeichen": "???",
  "annual_report.summary.archetype.lurker.name": "Stoik",
  "annual_report.summary.archetype.oracle.name": "Orakelj",
  "annual_report.summary.archetype.replier.name": "Metulj",
  "annual_report.summary.archetype.reveal": "Razkrij moj arhetip",
  "annual_report.summary.archetype.title_public": "Arhetip {name}",
  "annual_report.summary.archetype.title_self": "Vaš arhetip",
  "annual_report.summary.close": "Zapri",
  "annual_report.summary.copy_link": "Kopiraj povezavo",
  "annual_report.summary.followers.new_followers": "{count, plural, one {{counter} nov sledilec} two {{counter} nova sledilca} few {{counter} novi sledilci} other {{counter} novih sledilcev}}",
  "annual_report.summary.highlighted_post.title": "Najbolj priljubljena objava",
  "annual_report.summary.most_used_app.most_used_app": "najpogosteje uporabljena aplikacija",
  "annual_report.summary.most_used_hashtag.most_used_hashtag": "največkrat uporabljen ključnik",
  "annual_report.summary.new_posts.new_posts": "nove objave",
  "annual_report.summary.percentile.text": "<topLabel>S tem ste se uvrstili med zgornjih </topLabel><percentage></percentage><bottomLabel> uporabnikov domene {domain}.</bottomLabel>",
  "annual_report.summary.percentile.we_wont_tell_bernie": "Živi duši ne bomo povedali.",
  "annual_report.summary.share_elsewhere": "Deli drugje",
  "annual_report.summary.share_on_mastodon": "Deli na Mastodonu",
  "attachments_list.unprocessed": "(neobdelano)",
  "audio.hide": "Skrij zvok",
  "block_modal.remote_users_caveat": "Strežnik {domain} bomo pozvali, naj spoštuje vašo odločitev. Kljub temu pa ni gotovo, da bo strežnik prošnjo upošteval, saj nekateri strežniki blokiranja obravnavajo drugače. Javne objave bodo morda še vedno vidne neprijavljenim uporabnikom.",
  "block_modal.show_less": "Pokaži manj",
  "block_modal.show_more": "Pokaži več",
  "block_modal.they_will_know": "Ne more videti, da je blokiran.",
  "block_modal.title": "Blokiram uporabnika?",
  "boost_modal.combo": "Če želite naslednjič to preskočiti, lahko pritisnete {combo}",
  "boost_modal.reblog": "Izpostavim objavo?",
  "boost_modal.undo_reblog": "Ali želite preklicati izpostavitev objave?",
  "bundle_column_error.copy_stacktrace": "Kopiraj poročilo o napaki",
  "bundle_column_error.error.body": "Zahtevane strani ni mogoče upodobiti. Vzrok težave je morda hrošč v naši kodi ali pa nezdružljivost z brskalnikom.",
  "bundle_column_error.error.title": "Oh, ne!",
  "bundle_column_error.network.body": "Pri poskusu nalaganja te strani je prišlo do napake. Vzrok je lahko začasna težava z vašo internetno povezavo ali s tem strežnikom.",
  "bundle_column_error.network.title": "Omrežna napaka",
  "bundle_column_error.retry": "Poskusi znova",
  "bundle_column_error.return": "Nazaj domov",
  "bundle_column_error.routing.body": "Zahtevane strani ni mogoče najti. Ali ste prepričani, da je naslov URL v naslovni vrstici pravilen?",
  "bundle_column_error.routing.title": "404",
  "bundle_modal_error.close": "Zapri",
  "bundle_modal_error.message": "Med nalaganjem prikaza je prišlo do napake.",
  "bundle_modal_error.retry": "Poskusi znova",
  "callout.dismiss": "Opusti",
  "carousel.current": "<sr>Prosojnica</sr> {current, number} / {max, number}",
  "carousel.slide": "Prosojnica {current, number} od {max, number}",
  "closed_registrations.other_server_instructions": "Ker je Mastodon decentraliziran, lahko ustvarite račun na drugem strežniku in ste še vedno v interakciji s tem.",
  "closed_registrations_modal.description": "Odpiranje računa na domeni {domain} trenutno ni možno, upoštevajte pa, da ne potrebujete računa prav na domeni {domain}, da bi uporabljali Mastodon.",
  "closed_registrations_modal.find_another_server": "Najdi drug strežnik",
  "closed_registrations_modal.preamble": "Mastodon je decentraliziran, kar pomeni, da ni pomembno, kje ustvarite svoj račun; od koder koli je mogoče slediti in komunicirati z vsemi s tega strežnika. Strežnik lahko gostite tudi sami!",
  "closed_registrations_modal.title": "Registracija v Mastodon",
  "collections.create_collection": "Ustvari zbirko",
  "collections.delete_collection": "Izbriši zbirko",
  "collections.view_collection": "Pokaži zbirko",
  "column.about": "O programu",
  "column.blocks": "Blokirani uporabniki",
  "column.bookmarks": "Zaznamki",
  "column.community": "Krajevna časovnica",
  "column.create_list": "Ustvari seznam",
  "column.direct": "Zasebne omembe",
  "column.directory": "Prebrskaj profile",
  "column.domain_blocks": "Blokirane domene",
  "column.edit_list": "Uredi seznam",
  "column.favourites": "Priljubljeni",
  "column.firehose": "Viri v živo",
  "column.firehose_local": "Vir v živo za ta strežnik",
  "column.firehose_singular": "Vir v živo",
  "column.follow_requests": "Prošnje za sledenje",
  "column.home": "Domov",
  "column.list_members": "Upravljaj člane seznama",
  "column.lists": "Seznami",
  "column.mutes": "Utišani uporabniki",
  "column.notifications": "Obvestila",
  "column.pins": "Pripete objave",
  "column.public": "Združena časovnica",
  "column_back_button.label": "Nazaj",
  "column_header.hide_settings": "Skrij nastavitve",
  "column_header.moveLeft_settings": "Premakni stolpec na levo",
  "column_header.moveRight_settings": "Premakni stolpec na desno",
  "column_header.pin": "Pripni",
  "column_header.show_settings": "Pokaži nastavitve",
  "column_header.unpin": "Odpni",
  "column_search.cancel": "Prekliči",
  "community.column_settings.local_only": "Samo krajevno",
  "community.column_settings.media_only": "Samo predstavnosti",
  "community.column_settings.remote_only": "Samo oddaljeno",
  "compose.error.blank_post": "Objava ne sme biti prazna",
  "compose.language.change": "Spremeni jezik",
  "compose.language.search": "Poišči jezike ...",
  "compose.published.body": "Objavljeno.",
  "compose.published.open": "Odpri",
  "compose.saved.body": "Objava shranjena.",
  "compose_form.direct_message_warning_learn_more": "Več o tem",
  "compose_form.encryption_warning": "Objave na Mastodonu niso šifrirane od konca do konca. Prek Mastodona ne delite nobenih občutljivih informacij.",
  "compose_form.hashtag_warning": "Ta objava ne bo navedena pod nobenim ključnikom, ker ni javna. Samo javne objave lahko iščete s ključniki.",
  "compose_form.lock_disclaimer": "Vaš račun ni {locked}. Vsakdo vam lahko sledi in si ogleda objave, ki so namenjene samo sledilcem.",
  "compose_form.lock_disclaimer.lock": "zaklenjen",
  "compose_form.placeholder": "O čem razmišljate?",
  "compose_form.poll.duration": "Trajanje ankete",
  "compose_form.poll.multiple": "Izbira več možnosti",
  "compose_form.poll.option_placeholder": "Možnost {number}",
  "compose_form.poll.single": "Izbira ene možnosti",
  "compose_form.poll.switch_to_multiple": "Spremenite anketo, da omogočite izbiro več možnosti",
  "compose_form.poll.switch_to_single": "Spremenite anketo, da omogočite izbiro ene možnosti",
  "compose_form.poll.type": "Slog",
  "compose_form.publish": "Objavi",
  "compose_form.reply": "Odgovori",
  "compose_form.save_changes": "Posodobi",
  "compose_form.spoiler.marked": "Odstrani opozorilo o vsebini",
  "compose_form.spoiler.unmarked": "Dodaj opozorilo o vsebini",
  "compose_form.spoiler_placeholder": "Opozorilo o vsebini (ni obvezno)",
  "confirmation_modal.cancel": "Prekliči",
  "confirmations.block.confirm": "Blokiraj",
  "confirmations.delete.confirm": "Izbriši",
  "confirmations.delete.message": "Ali ste prepričani, da želite izbrisati to objavo?",
  "confirmations.delete.title": "Želite izbrisati objavo?",
  "confirmations.delete_list.confirm": "Izbriši",
  "confirmations.delete_list.message": "Ali ste prepričani, da želite trajno izbrisati ta seznam?",
  "confirmations.delete_list.title": "Želite izbrisati seznam?",
  "confirmations.discard_draft.confirm": "Opusti in nadaljuj",
  "confirmations.discard_draft.edit.cancel": "Nadaljuj z urejanjem",
  "confirmations.discard_draft.post.cancel": "Nadaljuj na osnutku",
  "confirmations.discard_edit_media.confirm": "Opusti",
  "confirmations.discard_edit_media.message": "Spremenjenega opisa predstavnosti ali predogleda niste shranili. Želite spremembe kljub temu opustiti?",
  "confirmations.follow_to_list.confirm": "Sledi in dodaj na seznam",
  "confirmations.follow_to_list.message": "Osebi {name} morate slediti, preden jo lahko dodate na seznam.",
  "confirmations.follow_to_list.title": "Naj sledim uporabniku?",
  "confirmations.logout.confirm": "Odjava",
  "confirmations.logout.message": "Ali ste prepričani, da se želite odjaviti?",
  "confirmations.logout.title": "Se želite odjaviti?",
  "confirmations.missing_alt_text.confirm": "Dodaj nadomestno besedilo",
  "confirmations.missing_alt_text.message": "Vaša objava vsebuje predstavnosti brez nadomestnega besedila. Če jih dodatno opišete, bodo dostopne večji množici ljudi.",
  "confirmations.missing_alt_text.secondary": "Vseeno objavi",
  "confirmations.missing_alt_text.title": "Dodam nadomestno besedilo?",
  "confirmations.mute.confirm": "Utišaj",
  "confirmations.private_quote_notify.cancel": "Nazaj k urejanju",
  "confirmations.private_quote_notify.confirm": "Objavi objavo",
  "confirmations.private_quote_notify.do_not_show_again": "Ne prikazuj mi več tega sporočila",
  "confirmations.quiet_post_quote_info.dismiss": "Ne opominjaj me več",
  "confirmations.quiet_post_quote_info.got_it": "Razumem",
  "confirmations.redraft.confirm": "Izbriši in preoblikuj",
  "confirmations.redraft.message": "Ali ste prepričani, da želite izbrisati to objavo in jo preoblikovati? Izkazi priljubljenosti in izpostavitve bodo izgubljeni, odgovori na izvirno objavo pa bodo osiroteli.",
  "confirmations.redraft.title": "Želite izbrisati in preoblikovati objavo?",
  "confirmations.remove_from_followers.confirm": "Odstrani sledilca",
  "confirmations.remove_from_followers.title": "Ali želite odstraniti sledilca?",
  "confirmations.revoke_quote.confirm": "Odstrani objavo",
  "confirmations.revoke_quote.message": "Tega dejanja ni možno povrniti.",
  "confirmations.revoke_quote.title": "Ali želite odstraniti objavo?",
  "confirmations.unblock.confirm": "Odblokiraj",
  "confirmations.unblock.title": "Ali želite odblokirati {name}?",
  "confirmations.unfollow.confirm": "Ne sledi več",
  "confirmations.unfollow.title": "Ali želite prenehati slediti {name}?",
  "confirmations.withdraw_request.confirm": "Umakni zahtevo",
  "content_warning.hide": "Skrij objavo",
  "content_warning.show": "Vseeno pokaži",
  "content_warning.show_more": "Pokaži več",
  "conversation.delete": "Izbriši pogovor",
  "conversation.mark_as_read": "Označi kot prebrano",
  "conversation.open": "Pokaži pogovor",
  "conversation.with": "Z {names}",
  "copy_icon_button.copied": "Kopirano v odložišče",
  "copypaste.copied": "Kopirano",
  "copypaste.copy_to_clipboard": "Kopiraj v odložišče",
  "directory.federated": "Iz znanega fediverzuma",
  "directory.local": "Samo iz {domain}",
  "directory.new_arrivals": "Novi prišleki",
  "directory.recently_active": "Nedavno aktiven/a",
  "disabled_account_banner.account_settings": "Nastavitve računa",
  "disabled_account_banner.text": "Vaš račun {disabledAccount} je trenutno onemogočen.",
  "dismissable_banner.community_timeline": "To so najnovejše javne objave oseb, katerih računi gostujejo na {domain}.",
  "dismissable_banner.dismiss": "Opusti",
  "dismissable_banner.public_timeline": "To so najnovejše javne objave ljudi s fediverzuma, ki jim sledijo ljudje na domeni {domain}.",
  "domain_block_modal.block": "Blokiraj strežnik",
  "domain_block_modal.block_account_instead": "Namesto tega blokiraj @{name}",
  "domain_block_modal.they_can_interact_with_old_posts": "Osebe s tega strežnika se lahko odzivajo na vaše stare objave.",
  "domain_block_modal.they_cant_follow": "Nihče s tega strežnika vam ne more slediti.",
  "domain_block_modal.they_wont_know": "Ne bodo vedeli, da so blokirani.",
  "domain_block_modal.title": "Blokiraj domeno?",
  "domain_block_modal.you_will_lose_num_followers": "Izgubili boste {followersCount, plural, one {{followersCountDisplay} sledilca} two {{followersCountDisplay} sledilca} few {{followersCountDisplay} sledilce} other {{followersCountDisplay} sledilcev}} in {followingCount, plural, one {{followingCountDisplay} osebo, ki ji sledite} two {{followingCountDisplay} osebi, ki jima sledite} few {{followingCountDisplay} osebe, ki jim sledite} other {{followingCountDisplay} oseb, ki jim sledite}}.",
  "domain_block_modal.you_will_lose_relationships": "Izgubili boste vse sledilce in ljudi, ki jim sledite na tem strežniku.",
  "domain_block_modal.you_wont_see_posts": "Objav ali obvestil uporabnikov s tega strežnika ne boste videli.",
  "domain_pill.activitypub_lets_connect": "Omogoča vam povezovanje in interakcijo z ljudmi, ki niso samo na Mastodonu, ampak tudi na drugih družbenih platformah.",
  "domain_pill.activitypub_like_language": "Protokol ActivityPub je kot jezik, v katerem se Mastodon pogovarja z drugimi družabnimi omrežji.",
  "domain_pill.server": "Strežnik",
  "domain_pill.their_handle": "Njegova/njena ročica:",
  "domain_pill.their_server": "Njegovo/njeno digitalno domovanje, kjer bivajo vse njegove/njene objave.",
  "domain_pill.their_username": "Njegov/njen edinstveni identifikator na njegovem/njenem strežniku. Uporabnike z istim uporabniškim imenom lahko najdete na različnih strežnikih.",
  "domain_pill.username": "Uporabniško ime",
  "domain_pill.whats_in_a_handle": "Kaj je v ročici?",
  "domain_pill.who_they_are": "Ker ročice povedo, kdo je kdo in kje je, lahko komunicirate z ljudmi po vsem spletu družbenih <button>platform, ki jih poganja ActivityPub</button>.",
  "domain_pill.who_you_are": "Ker ročice povedo, kdo ste in kje ste, lahko komunicirate z ljudmi po vsem spletu družbenih <button>platform, ki jih poganja ActivityPub</button>.",
  "domain_pill.your_handle": "Vaša ročica:",
  "domain_pill.your_server": "Vaše digitalno domovanje, kjer bivajo vse vaše objave. Vam ni všeč? Kadar koli ga prenesite med strežniki in z njim tudi svoje sledilce.",
  "domain_pill.your_username": "Vaš edinstveni identifikator na tem strežniku. Uporabnike z istim uporabniškim imenom je možno najti na različnih strežnikih.",
  "dropdown.empty": "Izberite možnost",
  "embed.instructions": "Vstavite to objavo na svojo spletno stran tako, da kopirate spodnjo kodo.",
  "embed.preview": "Takole bo videti:",
  "emoji_button.activity": "Dejavnost",
  "emoji_button.clear": "Počisti",
  "emoji_button.custom": "Po meri",
  "emoji_button.flags": "Zastave",
  "emoji_button.food": "Hrana in pijača",
  "emoji_button.label": "Vstavi emotikon",
  "emoji_button.nature": "Narava",
  "emoji_button.not_found": "Ni zadetkov med emotikoni",
  "emoji_button.objects": "Predmeti",
  "emoji_button.people": "Ljudje",
  "emoji_button.recent": "Pogosto uporabljeni",
  "emoji_button.search": "Poišči ...",
  "emoji_button.search_results": "Rezultati iskanja",
  "emoji_button.symbols": "Simboli",
  "emoji_button.travel": "Potovanja in kraji",
  "empty_column.account_hides_collections": "Ta uporabnik se je odločil, da te informacije ne bo delil",
  "empty_column.account_suspended": "Račun je suspendiran",
  "empty_column.account_timeline": "Tukaj ni objav!",
  "empty_column.account_unavailable": "Profil ni na voljo",
  "empty_column.blocks": "Niste še blokirali nobenega uporabnika.",
  "empty_column.bookmarked_statuses": "Zaenkrat še nimate zaznamovanih objav. Ko objavo zaznamujete, se pojavi tukaj.",
  "empty_column.community": "Krajevna časovnica je prazna. Napišite nekaj javnega, da se začne polniti!",
  "empty_column.direct": "Nimate še nobenih zasebnih omemb. Ko jih boste poslali ali prejeli, se bodo prikazale tukaj.",
  "empty_column.domain_blocks": "Zaenkrat ni blokiranih domen.",
  "empty_column.explore_statuses": "Trenutno ni novih trendov. Preverite znova kasneje!",
  "empty_column.favourited_statuses": "Nimate priljubljenih objav. Ko boste kakšno dodali med priljubljene, bo prikazana tukaj.",
  "empty_column.favourites": "Nihče še ni vzljubil te objave. Ko jo bo nekdo, bo naveden tukaj.",
  "empty_column.follow_requests": "Nimate prošenj za sledenje. Ko boste prejeli kakšno, se bo prikazala tukaj.",
  "empty_column.followed_tags": "Zaenkrat ne sledite še nobenemu ključniku. Ko boste, se bo pojavil tukaj.",
  "empty_column.hashtag": "V tem ključniku ni še nič.",
  "empty_column.home": "Vaša domača časovnica je prazna! Sledite več osebam, da jo zapolnite.",
  "empty_column.list": "Na tem seznamu ni ničesar. Ko bodo člani tega seznama kaj objavili, se bodo te objave pojavile tukaj.",
  "empty_column.mutes": "Niste utišali še nobenega uporabnika.",
  "empty_column.notification_requests": "Vse prebrano! Tu ni ničesar več. Ko prejmete nova obvestila, se bodo pojavila tu glede na vaše nastavitve.",
  "empty_column.notifications": "Nimate še nobenih obvestil. Povežite se z drugimi, da začnete pogovor.",
  "empty_column.public": "Tukaj ni ničesar! Napišite nekaj javnega ali pa ročno sledite uporabnikom iz drugih strežnikov, da se bo napolnilo",
  "error.unexpected_crash.explanation": "Zaradi hrošča v naši kodi ali težave z združljivostjo brskalnika te strani ni mogoče ustrezno prikazati.",
  "error.unexpected_crash.explanation_addons": "Te strani ni mogoče ustrezno prikazati. To napako najverjetneje povzroča dodatek brskalnika ali samodejna orodja za prevajanje.",
  "error.unexpected_crash.next_steps": "Poskusite osvežiti stran. Če to ne pomaga, boste morda še vedno lahko uporabljali Mastodon prek drugega brskalnika ali z domorodno aplikacijo.",
  "error.unexpected_crash.next_steps_addons": "Poskusite jih onemogočiti in osvežiti stran. Če to ne pomaga, boste morda še vedno lahko uporabljali Mastodon prek drugega brskalnika ali z domorodno aplikacijo.",
  "errors.unexpected_crash.copy_stacktrace": "Kopiraj sled sklada na odložišče",
  "errors.unexpected_crash.report_issue": "Prijavi težavo",
  "explore.suggested_follows": "Ljudje",
  "explore.title": "V trendu",
  "explore.trending_links": "Novice",
  "explore.trending_statuses": "Objave",
  "explore.trending_tags": "Ključniki",
  "featured_carousel.current": "<sr>Objava</sr> {current, number} / {max, number}",
  "featured_carousel.slide": "Objava {current, number} od {max, number}",
  "filter_modal.added.context_mismatch_explanation": "Ta kategorija filtra ne velja za kontekst, v katerem ste dostopali do te objave. Če želite, da je objava filtrirana tudi v tem kontekstu, morate urediti filter.",
  "filter_modal.added.context_mismatch_title": "Neujemanje konteksta!",
  "filter_modal.added.expired_explanation": "Ta kategorija filtra je pretekla. Morali boste spremeniti datum veljavnosti, da bo veljal še naprej.",
  "filter_modal.added.expired_title": "Filter je pretekel!",
  "filter_modal.added.review_and_configure": "Če želite pregledati in nadalje prilagoditi kategorijo filtra, obiščite {settings_link}.",
  "filter_modal.added.review_and_configure_title": "Nastavitve filtra",
  "filter_modal.added.settings_link": "stran nastavitev",
  "filter_modal.added.short_explanation": "Ta objava je bila dodana v naslednjo kategorijo filtra: {title}.",
  "filter_modal.added.title": "Filter dodan!",
  "filter_modal.select_filter.context_mismatch": "ne velja za ta kontekst",
  "filter_modal.select_filter.expired": "poteklo",
  "filter_modal.select_filter.prompt_new": "Nova kategorija: {name}",
  "filter_modal.select_filter.search": "Išči ali ustvari",
  "filter_modal.select_filter.subtitle": "Uporabite obstoječo kategorijo ali ustvarite novo",
  "filter_modal.select_filter.title": "Filtriraj to objavo",
  "filter_modal.title.status": "Filtrirajte objavo",
  "filter_warning.matches_filter": "Se ujema s filtrom »<span>{title}</span>«",
  "filtered_notifications_banner.pending_requests": "Od {count, plural, =0 {nikogar, ki bi ga poznali} one {nekoga, ki ga morda poznate} two {dveh ljudi, ki ju morda poznate} other {ljudi, ki jih morda poznate}}",
  "filtered_notifications_banner.title": "Filtrirana obvestila",
  "firehose.all": "Vse",
  "firehose.local": "Ta strežnik",
  "firehose.remote": "Drugi strežniki",
  "follow_request.authorize": "Overi",
  "follow_request.reject": "Zavrni",
  "follow_requests.unlocked_explanation": "Čeprav vaš račun ni zaklenjen, zaposleni pri {domain} menijo, da bi morda želeli pregledati zahteve za sledenje teh računov ročno.",
  "follow_suggestions.curated_suggestion": "Izbor osebja",
  "follow_suggestions.dismiss": "Ne pokaži več",
  "follow_suggestions.featured_longer": "Osebno izbrala ekipa {domain}",
  "follow_suggestions.friends_of_friends_longer": "Priljubljeno med osebami, ki jim sledite",
  "follow_suggestions.hints.featured": "Ta profil so izbrali skrbniki strežnika {domain}.",
  "follow_suggestions.hints.friends_of_friends": "Ta profil je priljubljen med osebami, ki jim sledite.",
  "follow_suggestions.hints.most_followed": "Ta profil na strežniku {domain} je en izmed najbolj sledenih.",
  "follow_suggestions.hints.most_interactions": "Ta profil na strežniku {domain} je nedavno prejel veliko pozornosti.",
  "follow_suggestions.hints.similar_to_recently_followed": "Ta profil je podoben profilom, ki ste jim nedavno začeli slediti.",
  "follow_suggestions.personalized_suggestion": "Osebno prilagojen predlog",
  "follow_suggestions.popular_suggestion": "Priljubljen predlog",
  "follow_suggestions.popular_suggestion_longer": "Priljubljeno na {domain}",
  "follow_suggestions.similar_to_recently_followed_longer": "Podobno profilom, ki ste jim pred kratkim sledili",
  "follow_suggestions.view_all": "Pokaži vse",
  "follow_suggestions.who_to_follow": "Komu slediti",
  "followed_tags": "Sledeni ključniki",
  "footer.about": "O Mastodonu",
  "footer.about_mastodon": "O Mastodonu",
  "footer.about_server": "O {domain}",
  "footer.directory": "Imenik profilov",
  "footer.get_app": "Prenesite aplikacijo",
  "footer.keyboard_shortcuts": "Tipkovne bližnjice",
  "footer.privacy_policy": "Pravilnik o zasebnosti",
  "footer.source_code": "Pokaži izvorno kodo",
  "footer.status": "Stanje",
  "footer.terms_of_service": "Pogoji uporabe",
  "form_field.optional": "(neobvezno)",
  "generic.saved": "Shranjeno",
  "getting_started.heading": "Kako začeti",
  "hashtag.admin_moderation": "Odpri vmesnik za moderiranje za #{name}",
  "hashtag.column_header.tag_mode.all": "in {additional}",
  "hashtag.column_header.tag_mode.any": "ali {additional}",
  "hashtag.column_header.tag_mode.none": "brez {additional}",
  "hashtag.column_settings.select.no_options_message": "Ni najdenih predlogov",
  "hashtag.column_settings.select.placeholder": "Vnesi ključnike …",
  "hashtag.column_settings.tag_mode.all": "Vse od naštetega",
  "hashtag.column_settings.tag_mode.any": "Karkoli od naštetega",
  "hashtag.column_settings.tag_mode.none": "Nič od naštetega",
  "hashtag.column_settings.tag_toggle": "Za ta stolpec vključi dodatne oznake",
  "hashtag.counter_by_accounts": "{count, plural, one {{counter} udeleženec} two {{counter} udeleženca} few {{counter} udeležencev} other {{counter} udeležencev}}",
  "hashtag.counter_by_uses": "{count, plural, one {{counter} objava} two {{counter} posts} few {{counter} objavi} other {{counter} objav}}",
  "hashtag.counter_by_uses_today": "{count, plural, one {{counter} objava} two {{counter} objavi} few {{counter} objav} other {{counter} objav}}",
  "hashtag.feature": "Izpostavi v profilu",
  "hashtag.follow": "Sledi ključniku",
  "hashtag.mute": "Utišaj #{hashtag}",
  "hashtag.unfeature": "Ne izpostavljaj v profilu",
  "hashtag.unfollow": "Nehaj slediti ključniku",
  "hashtags.and_other": "… in še {count, plural, other {#}}",
  "hints.profiles.followers_may_be_missing": "Sledilci za ta profil morda manjkajo.",
  "hints.profiles.follows_may_be_missing": "Osebe, ki jim ta profil sledi, morda manjkajo.",
  "hints.profiles.posts_may_be_missing": "Nekatere objave s tega profila morda manjkajo.",
  "hints.profiles.see_more_followers": "Pokaži več sledilcev na {domain}",
  "hints.profiles.see_more_follows": "Pokaži več sledenih ljudi na zbirališču {domain}",
  "hints.profiles.see_more_posts": "Pokaži več objav na {domain}",
  "home.column_settings.show_quotes": "Pokaži citate",
  "home.column_settings.show_reblogs": "Pokaži izpostavitve",
  "home.column_settings.show_replies": "Pokaži odgovore",
  "home.hide_announcements": "Skrij obvestila",
  "home.pending_critical_update.body": "Čim prej posodobite svoj strežnik Mastodon!",
  "home.pending_critical_update.link": "Glejte posodobitve",
  "home.pending_critical_update.title": "Na voljo je kritična varnostna posodobbitev!",
  "home.show_announcements": "Pokaži obvestila",
  "ignore_notifications_modal.disclaimer": "Mastodon ne more obveščati uporabnikov, da ste prezrli njihova obvestila. Tudi če jih prezrete, jih lahko uporabniki še vedno pošiljajo.",
  "ignore_notifications_modal.filter_instead": "Raje filtriraj",
  "ignore_notifications_modal.filter_to_act_users": "Še vedno boste lahko sprejeli, zavrnili ali prijavili uporabnike",
  "ignore_notifications_modal.filter_to_avoid_confusion": "Filtriranje pomaga pri izogibanju morebitni zmedi",
  "ignore_notifications_modal.filter_to_review_separately": "Filtrirana obvestila lahko pregledate ločeno",
  "ignore_notifications_modal.ignore": "Prezri obvestila",
  "ignore_notifications_modal.limited_accounts_title": "Naj prezrem obvestila moderiranih računov?",
  "ignore_notifications_modal.new_accounts_title": "Naj prezrem obvestila novih računov?",
  "ignore_notifications_modal.not_followers_title": "Naj prezrem obvestila ljudi, ki vam ne sledijo?",
  "ignore_notifications_modal.not_following_title": "Naj prezrem obvestila ljudi, ki jim ne sledite?",
  "ignore_notifications_modal.private_mentions_title": "Naj prezrem obvestila od nezaželenih zasebnih omemb?",
  "info_button.label": "Pomoč",
  "info_button.what_is_alt_text": "<h1>Kaj je nadomestno besedilo?</h1> <p>Z nadomestnim besedilom dodatno opišemo sliko in tako pomagamo slabovidnim, ljudem s slabo internetno povezavo in tistim, ki jim manjka kontekst.</p> <p>Vaša objava bo veliko bolj dostopna in razumljiva, če boste napisali jasno, jedrnato in nepristransko nadomestno besedilo.</p> <ul> <li>Izpostavite pomembne elemente.</li> <li>Povzemite besedilo v slikah.</li> <li>Pišite v celih stavkih.</li> <li>Zajemite bistvo, ne dolgovezite.</li> <li>Opišite težnje in ključna odkritja, ki ste jih razbrali iz zapletenih grafik (npr. diagramov ali zemljevidov).</li> </ul>",
  "interaction_modal.go": "Naprej",
  "interaction_modal.no_account_yet": "Še nimate računa?",
  "interaction_modal.on_another_server": "Na drugem strežniku",
  "interaction_modal.on_this_server": "Na tem strežniku",
  "interaction_modal.title": "Za nadaljevanje se prijavite",
  "interaction_modal.username_prompt": "Npr. {example}",
  "intervals.full.days": "{number, plural, one {# dan} two {# dni} few {# dni} other {# dni}}",
  "intervals.full.hours": "{number, plural, one {# ura} two {# uri} few {# ure} other {# ur}}",
  "intervals.full.minutes": "{number, plural, one {# minuta} two {# minuti} few {# minute} other {# minut}}",
  "keyboard_shortcuts.back": "Pojdi nazaj",
  "keyboard_shortcuts.blocked": "Odpri seznam blokiranih uporabnikov",
  "keyboard_shortcuts.boost": "Izpostavi objavo",
  "keyboard_shortcuts.column": "Pozornost na stolpec",
  "keyboard_shortcuts.compose": "Pozornost na območje za sestavljanje besedila",
  "keyboard_shortcuts.description": "Opis",
  "keyboard_shortcuts.down": "Premakni navzdol po seznamu",
  "keyboard_shortcuts.enter": "Odpri objavo",
  "keyboard_shortcuts.favourite": "Priljubljena objava",
  "keyboard_shortcuts.favourites": "Odpri seznam priljubljenih",
  "keyboard_shortcuts.federated": "Odpri združeno časovnico",
  "keyboard_shortcuts.heading": "Tipkovne bližnjice",
  "keyboard_shortcuts.home": "Odpri domačo časovnico",
  "keyboard_shortcuts.hotkey": "Hitra tipka",
  "keyboard_shortcuts.legend": "Pokaži to legendo",
  "keyboard_shortcuts.local": "Odpri krajevno časovnico",
  "keyboard_shortcuts.mention": "Omeni avtorja",
  "keyboard_shortcuts.muted": "Odpri seznam utišanih uporabnikov",
  "keyboard_shortcuts.my_profile": "Odprite svoj profil",
  "keyboard_shortcuts.notifications": "Odpri stolpec z obvestili",
  "keyboard_shortcuts.open_media": "Odpri predstavnost",
  "keyboard_shortcuts.pinned": "Odpri seznam pripetih objav",
  "keyboard_shortcuts.profile": "Odpri avtorjev profil",
  "keyboard_shortcuts.quote": "Citiraj objavo",
  "keyboard_shortcuts.reply": "Odgovori na objavo",
  "keyboard_shortcuts.requests": "Odpri seznam s prošnjami za sledenje",
  "keyboard_shortcuts.search": "Pozornost na iskalno vrstico",
  "keyboard_shortcuts.spoilers": "Pokaži/skrij polje CW",
  "keyboard_shortcuts.start": "Odpri stolpec \"začni\"",
  "keyboard_shortcuts.toggle_hidden": "Pokaži/skrij besedilo za CW",
  "keyboard_shortcuts.toggle_sensitivity": "Pokaži/skrij predstavnosti",
  "keyboard_shortcuts.toot": "Začni povsem novo objavo",
  "keyboard_shortcuts.top": "Premakni na vrh seznama",
  "keyboard_shortcuts.translate": "za prevod objave",
  "keyboard_shortcuts.unfocus": "Odstrani pozornost z območja za sestavljanje besedila/iskanje",
  "keyboard_shortcuts.up": "Premakni navzgor po seznamu",
  "learn_more_link.got_it": "Razumem",
  "learn_more_link.learn_more": "Več o tem",
  "lightbox.close": "Zapri",
  "lightbox.next": "Naslednji",
  "lightbox.previous": "Prejšnji",
  "lightbox.zoom_in": "Približaj na dejansko velikost",
  "lightbox.zoom_out": "Čez cel prikaz",
  "limited_account_hint.action": "Vseeno pokaži profil",
  "limited_account_hint.title": "Profil so moderatorji strežnika {domain} skrili.",
  "link_preview.author": "Avtor/ica {name}",
  "link_preview.more_from_author": "Več od {name}",
  "link_preview.shares": "{count, plural, one {{counter} objava} two {{counter} objavi} few {{counter} objave} other {{counter} objav}}",
  "lists.add_member": "Dodaj",
  "lists.add_to_list": "Dodaj na seznam",
  "lists.add_to_lists": "Dodaj {name} na sezname",
  "lists.create": "Ustvari",
  "lists.create_a_list_to_organize": "Uredite si domači vir z novim seznamom",
  "lists.create_list": "Ustvari seznam",
  "lists.delete": "Izbriši seznam",
  "lists.done": "Opravljeno",
  "lists.edit": "Uredi seznam",
  "lists.exclusive": "Skrij člane v domovanju",
  "lists.exclusive_hint": "Objave vseh, ki so na tem seznamu, se ne pokažejo v vašem domačem viru. Tako se izognete podvojenim objavam.",
  "lists.find_users_to_add": "Poišči člane za dodajanje",
  "lists.list_members_count": "{count, plural, one {# član} two {# člana} few {# člani} other {# članov}}",
  "lists.list_name": "Ime seznama",
  "lists.new_list_name": "Novo ime seznama",
  "lists.no_lists_yet": "Ni seznamov.",
  "lists.no_members_yet": "Ni še nobenega člana.",
  "lists.no_results_found": "Ni rezultatov.",
  "lists.remove_member": "Odstrani",
  "lists.replies_policy.followed": "Vsem sledenim uporabnikom",
  "lists.replies_policy.list": "Članom seznama",
  "lists.replies_policy.none": "Nikomur",
  "lists.save": "Shrani",
  "lists.search": "Iskanje",
  "lists.show_replies_to": "Vključi odgovore, katerih pošiljatelji so člani seznama in prejemniki",
  "load_pending": "{count, plural, one {# nov element} two {# nova elementa} few {# novi elementi} other {# novih elementov}}",
  "loading_indicator.label": "Nalaganje …",
  "media_gallery.hide": "Skrij",
  "moved_to_account_banner.text": "Vaš račun {disabledAccount} je trenutno onemogočen, ker ste se prestavili na {movedToAccount}.",
  "mute_modal.hide_from_notifications": "Skrijte se pred obvestili",
  "mute_modal.hide_options": "Skrij možnosti",
  "mute_modal.indefinite": "Dokler jim ne povrnem glasu",
  "mute_modal.show_options": "Pokaži možnosti",
  "mute_modal.they_can_mention_and_follow": "Lahko vas omenijo ali vam sledijo, vi pa jih ne morete videti.",
  "mute_modal.they_wont_know": "Ne bodo vedeli, da so utišani.",
  "mute_modal.title": "Utišaj uporabnika?",
  "mute_modal.you_wont_see_mentions": "Objav, ki jih omenjajo, ne boste videli.",
  "mute_modal.you_wont_see_posts": "Še vedno vidijo vaše objave, vi pa ne njihovih.",
  "navigation_bar.about": "O Mastodonu",
  "navigation_bar.account_settings": "Geslo in varnost",
  "navigation_bar.administration": "Upravljanje",
  "navigation_bar.advanced_interface": "Odpri v naprednem spletnem vmesniku",
  "navigation_bar.automated_deletion": "Samodejno brisanje objav",
  "navigation_bar.blocks": "Blokirani uporabniki",
  "navigation_bar.bookmarks": "Zaznamki",
  "navigation_bar.direct": "Zasebne omembe",
  "navigation_bar.domain_blocks": "Blokirane domene",
  "navigation_bar.favourites": "Priljubljeni",
  "navigation_bar.filters": "Utišane besede",
  "navigation_bar.follow_requests": "Prošnje za sledenje",
  "navigation_bar.followed_tags": "Sledeni ključniki",
  "navigation_bar.follows_and_followers": "Sledenja in sledilci",
  "navigation_bar.import_export": "Uvoz in izvoz",
  "navigation_bar.lists": "Seznami",
  "navigation_bar.live_feed_local": "Vir v živo (krajevno)",
  "navigation_bar.live_feed_public": "Vir v živo (javno)",
  "navigation_bar.logout": "Odjava",
  "navigation_bar.moderation": "Moderiranje",
  "navigation_bar.more": "Več",
  "navigation_bar.mutes": "Utišani uporabniki",
  "navigation_bar.opened_in_classic_interface": "Objave, računi in druge specifične strani se privzeto odprejo v klasičnem spletnem vmesniku.",
  "navigation_bar.preferences": "Nastavitve",
  "navigation_bar.privacy_and_reach": "Zasebnost in dosegljivost",
  "navigation_bar.search": "Iskanje",
  "not_signed_in_indicator.not_signed_in": "Za dostop do tega vira se morate prijaviti.",
  "notification.admin.report": "{name} je prijavil/a {target}",
  "notification.admin.report_account": "{name} je prijavil/a {count, plural, one {# objavo} two {# objavi} few {# objave} other {# objav}} od {target} zaradi {category}",
  "notification.admin.report_account_other": "{name} je prijavil/a {count, plural, one {# objavo} two {# objavi} few {# objave} other {# objav}} od {target}",
  "notification.admin.report_statuses": "{name} je prijavil/a {target} zaradi {category}",
  "notification.admin.report_statuses_other": "{name} je prijavil/a {target}",
  "notification.admin.sign_up": "{name} se je vpisal/a",
  "notification.admin.sign_up.name_and_others": "Prijavili so se {name} in {count, plural, one {# druga oseba} two {# drugi osebi} few {# druge osebe} other {# drugih oseb}}",
  "notification.annual_report.message": "Čaka vas vaš #Wrapstodon {year}! Razkrijte svoje letošnje nepozabne trenutke na Mastodonu!",
  "notification.annual_report.view": "Pokaži #Wrapstodon",
  "notification.favourite": "{name} je vzljubil/a vašo objavo",
  "notification.favourite.name_and_others_with_link": "{name} in <a>{count, plural, one {# druga oseba} two {# drugi osebi} few {# druge osebe} other {# drugih oseb}}</a> je dodalo vašo objavo med priljubljene",
  "notification.favourite_pm": "{name} je dodalo vašo zasebno omembo med priljubljene",
  "notification.favourite_pm.name_and_others_with_link": "{name} in <a>{count, plural, one {# druga oseba} two {# drugi osebi} few {# druge osebe} other {# drugih oseb}}</a> je dodalo vašo zasebno omembo med priljubljene",
  "notification.follow": "{name} vam sledi",
  "notification.follow.name_and_others": "{name} in {count, plural, one {<a># druga oseba</a> sta ti sledila} two {<a># drugi osebi</a> so ti sledili} few {<a># druge osebe</a> so ti sledili} other {<a># drugih oseb</a> ti je sledilo}}",
  "notification.follow_request": "{name} vam želi slediti",
  "notification.follow_request.name_and_others": "{name} in {count, plural, one {# druga oseba bi ti rada sledila} two {# drugi osebi bi ti radi sledili} few {# druge osebe bi ti radi sledili} other {# drugih oseb bi ti radi sledili}}",
  "notification.label.mention": "Omemba",
  "notification.label.private_mention": "Zasebna omemba",
  "notification.label.private_reply": "Zasebni odgovor",
  "notification.label.quote": "{name} je citiral/a vašo objavo",
  "notification.label.reply": "Odgovori",
  "notification.mention": "Omemba",
  "notification.mentioned_you": "{name} vas je omenil/a",
  "notification.moderation-warning.learn_more": "Več o tem",
  "notification.moderation_warning": "Prejeli ste opozorilo moderatorjev",
  "notification.moderation_warning.action_delete_statuses": "Nekatere vaše objave so odstranjene.",
  "notification.moderation_warning.action_disable": "Vaš račun je bil onemogočen.",
  "notification.moderation_warning.action_mark_statuses_as_sensitive": "Nekatere vaše objave so bile označene kot občutljive.",
  "notification.moderation_warning.action_none": "Vaš račun je prejel opozorilo moderatorjev.",
  "notification.moderation_warning.action_sensitive": "Vaše objave bodo odslej označene kot občutljive.",
  "notification.moderation_warning.action_silence": "Vaš račun je bil omejen.",
  "notification.moderation_warning.action_suspend": "Vaš račun je bil suspendiran.",
  "notification.own_poll": "Vaša anketa je zaključena",
  "notification.poll": "Anketa, v kateri ste sodelovali, je zaključena",
  "notification.reblog": "{name} je izpostavila/a vašo objavo",
  "notification.reblog.name_and_others_with_link": "{name} in <a>{count, plural, one {# druga oseba</a> sta izpostavila tvojo objavo} two {# drugi osebi</a> so izpostavili tvojo objavo} few {# druge osebe</a> so izpostavili tvojo objavo} other {# drugih oseb</a> so izpostavili tvojo objavo}}",
  "notification.relationships_severance_event": "Povezave z {name} prekinjene",
  "notification.relationships_severance_event.account_suspension": "Skrbnik na {from} je suspendiral račun {target}, kar pomeni, da od računa ne morete več prejemati posodobitev ali imeti z njim interakcij.",
  "notification.relationships_severance_event.domain_block": "Skrbnik na {from} je blokiral domeno {target}, vključno z vašimi sledilci ({followersCount}) in {followingCount, plural, one {# računom, ki mu sledite} two {# računoma, ki jima sledite} few {# računi, ki jim sledite} other {# računi, ki jim sledite}}.",
  "notification.relationships_severance_event.learn_more": "Več o tem",
  "notification.relationships_severance_event.user_domain_block": "Blokirali ste domeno {target}, vključno z vašimi sledilci ({followersCount}) in {followingCount, plural, one {# računom, ki mu sledite} two {# računoma, ki jima sledite} few {# računi, ki jim sledite} other {# računi, ki jim sledite}}.",
  "notification.status": "{name} je pravkar objavil/a",
  "notification.update": "{name} je uredil(a) objavo",
  "notification_requests.accept": "Sprejmi",
  "notification_requests.accept_multiple": "{count, plural, one {Sprejmi # prošnjo …} two {Sprejmi # prošnji …} few {Sprejmi # prošnje …} other {Sprejmi # prošenj …}}",
  "notification_requests.confirm_accept_multiple.button": "{count, plural, one {Sprejmi prošnjo} two {Sprejmi prošnji} other {Sprejmi prošnje}}",
  "notification_requests.confirm_accept_multiple.message": "Sprejeti nameravate {count, plural, one {eno prošnjo za obvestila} two {dve prošnji za obvestila} few {# prošnje za obvestila} other {# prošenj za obvestila}}. Ali ste prepričani?",
  "notification_requests.confirm_accept_multiple.title": "Ali želite sprejeti zahteve za obvestila?",
  "notification_requests.confirm_dismiss_multiple.button": "{count, plural, one {Zavrni prošnjo} two {Zavrni prošnji} other {Zavrni prošnje}}",
  "notification_requests.confirm_dismiss_multiple.message": "Zavrniti nameravate {count, plural, one {eno prošnjo za obvestila} two {dve prošnji za obvestila} few {# prošnje za obvestila} other {# prošenj za obvestila}}. Do {count, plural, one {nje} two {njiju} other {njih}} ne boste več mogli dostopati. Ali ste prepričani?",
  "notification_requests.confirm_dismiss_multiple.title": "Želite opustiti zahteve za obvestila?",
  "notification_requests.dismiss": "Zavrni",
  "notification_requests.dismiss_multiple": "{count, plural, one {Zavrni # prošnjo …} two {Zavrni # prošnji …} few {Zavrni # prošnje …} other {Zavrni # prošenj …}}",
  "notification_requests.edit_selection": "Uredi",
  "notification_requests.exit_selection": "Opravljeno",
  "notification_requests.explainer_for_limited_account": "Obvestila za ta račun so bila filtrirana, ker je ta račun omejil moderator.",
  "notification_requests.explainer_for_limited_remote_account": "Obvestila za ta račun so bila filtrirana, ker je račun ali njegov strežnik omejil moderator.",
  "notification_requests.maximize": "Maksimiraj",
  "notification_requests.minimize_banner": "Zloži pasico filtriranih obvestil",
  "notification_requests.notifications_from": "Obvestila od {name}",
  "notification_requests.title": "Filtrirana obvestila",
  "notification_requests.view": "Pokaži obvestila",
  "notifications.clear": "Počisti obvestila",
  "notifications.clear_confirmation": "Ali ste prepričani, da želite trajno izbrisati vsa svoja obvestila?",
  "notifications.clear_title": "Želite počistiti obvestila?",
  "notifications.column_settings.admin.report": "Nove prijave:",
  "notifications.column_settings.admin.sign_up": "Novi vpisi:",
  "notifications.column_settings.alert": "Namizna obvestila",
  "notifications.column_settings.favourite": "Priljubljeni:",
  "notifications.column_settings.filter_bar.advanced": "Prikaži vse kategorije",
  "notifications.column_settings.filter_bar.category": "Vrstica za hitro filtriranje",
  "notifications.column_settings.follow": "Novi sledilci:",
  "notifications.column_settings.follow_request": "Nove prošnje za sledenje:",
  "notifications.column_settings.group": "Združi",
  "notifications.column_settings.mention": "Omembe:",
  "notifications.column_settings.poll": "Rezultati ankete:",
  "notifications.column_settings.push": "Potisna obvestila",
  "notifications.column_settings.quote": "Citati:",
  "notifications.column_settings.reblog": "Izpostavitve:",
  "notifications.column_settings.show": "Pokaži v stolpcu",
  "notifications.column_settings.sound": "Predvajaj zvok",
  "notifications.column_settings.status": "Nove objave:",
  "notifications.column_settings.unread_notifications.category": "Neprebrana obvestila",
  "notifications.column_settings.unread_notifications.highlight": "Poudari neprebrana obvestila",
  "notifications.column_settings.update": "Urejanja:",
  "notifications.filter.all": "Vse",
  "notifications.filter.boosts": "Izpostavitev",
  "notifications.filter.favourites": "Priljubljeni",
  "notifications.filter.follows": "Sledi",
  "notifications.filter.mentions": "Omembe",
  "notifications.filter.polls": "Rezultati anket",
  "notifications.filter.statuses": "Posodobitve pri osebah, ki jih spremljate",
  "notifications.grant_permission": "Dovoli.",
  "notifications.group": "{count} obvestil",
  "notifications.mark_as_read": "Vsa obvestila označi kot prebrana",
  "notifications.permission_denied": "Namizna obvestila niso na voljo zaradi poprej zavrnjene zahteve dovoljenja brskalnika.",
  "notifications.permission_denied_alert": "Namiznih obvestil ni mogoče omogočiti, ker je bilo dovoljenje brskalnika že prej zavrnjeno",
  "notifications.permission_required": "Namizna obvestila niso na voljo, ker zahtevano dovoljenje ni bilo podeljeno.",
  "notifications.policy.accept": "Sprejmi",
  "notifications.policy.accept_hint": "Pokaži med obvestili",
  "notifications.policy.drop": "Prezri",
  "notifications.policy.drop_hint": "Pošlji v pozabo, od koder se nikdar nič ne vrne",
  "notifications.policy.filter": "Filtriraj",
  "notifications.policy.filter_hint": "Pošlji med filtrirana prejeta obvestila",
  "notifications.policy.filter_limited_accounts_hint": "Omejeno s strani moderatorjev strežnika",
  "notifications.policy.filter_limited_accounts_title": "Moderirani računi",
  "notifications.policy.filter_new_accounts.hint": "Ustvarjen v {days, plural, one {zadnjem # dnevu} two {zadnjih # dnevih} few {zadnjih # dnevih} other {zadnjih # dnevih}}",
  "notifications.policy.filter_new_accounts_title": "Novi računi",
  "notifications.policy.filter_not_followers_hint": "Vključujoč ljudi, ki vam sledijo manj kot {days, plural, one {# dan} two {# dneva} few {# dni} other {# dni}}",
  "notifications.policy.filter_not_followers_title": "Ljudje, ki vam ne sledijo",
  "notifications.policy.filter_not_following_hint": "Dokler jih ročno ne odobrite",
  "notifications.policy.filter_not_following_title": "Ljudje, ki jim ne sledite",
  "notifications.policy.filter_private_mentions_hint": "Filtrirano, razen če je odgovor na vašo lastno omembo ali če sledite pošiljatelju",
  "notifications.policy.filter_private_mentions_title": "Neželene zasebne omembe",
  "notifications.policy.title": "Upravljaj obvestila od ...",
  "notifications_permission_banner.enable": "Omogoči obvestila na namizju",
  "notifications_permission_banner.how_to_control": "Če želite prejemati obvestila, ko Mastodon ni odprt, omogočite namizna obvestila. Natančno lahko nadzirate, katere vrste interakcij naj tvorijo namizna obvestila; ko so omogočena, za to uporabite gumb {icon} zgoraj.",
  "notifications_permission_banner.title": "Nikoli ne zamudite ničesar",
  "onboarding.follows.back": "Nazaj",
  "onboarding.follows.empty": "Žal trenutno ni mogoče prikazati nobenih rezultatov. Lahko poskusite z iskanjem ali brskanjem po strani za raziskovanje, da poiščete osebe, ki jim želite slediti, ali poskusite znova pozneje.",
  "onboarding.follows.search": "Išči",
  "onboarding.follows.title": "Vaš prvi korak je, da sledite ljudem",
  "onboarding.profile.discoverable": "Naj bo moj profil mogoče najti",
  "onboarding.profile.discoverable_hint": "Ko se odločite za razkrivanje na Mastodonu, se lahko vaše objave pojavijo v rezultatih iskanja in trendih, vaš profil pa se lahko predlaga ljudem, ki imajo podobne interese kot vi.",
  "onboarding.profile.display_name": "Pojavno ime",
  "onboarding.profile.display_name_hint": "Vaše polno ime ali lažno ime ...",
  "onboarding.profile.note": "Biografija",
  "onboarding.profile.note_hint": "Lahko @omenite druge osebe ali dodate #ključnike ...",
  "onboarding.profile.title": "Nastavitev profila",
  "onboarding.profile.upload_avatar": "Naloži sliko profila",
  "onboarding.profile.upload_header": "Naloži glavo profila",
  "password_confirmation.exceeds_maxlength": "Potrditev gesla presega največjo dolžino gesla",
  "password_confirmation.mismatching": "Potrdilo gesla se ne ujema.",
  "picture_in_picture.restore": "Postavi nazaj",
  "poll.closed": "Zaprto",
  "poll.refresh": "Osveži",
  "poll.reveal": "Poglej rezultate",
  "poll.total_people": "{count, plural, one {# oseba} two {# osebi} few {# osebe} other {# oseb}}",
  "poll.total_votes": "{count, plural, one {# glas} two {# glasova} few {# glasovi} other {# glasov}}",
  "poll.vote": "Glasuj",
  "poll.voted": "Glasovali ste za ta odgovor",
  "poll.votes": "{votes, plural, one {# glas} two {# glasova} few {# glasovi} other {# glasov}}",
  "poll_button.add_poll": "Dodaj anketo",
  "poll_button.remove_poll": "Odstrani anketo",
  "privacy.change": "Spremeni zasebnost objave",
  "privacy.direct.long": "Vsem omenjenim v objavi",
  "privacy.direct.short": "Zasebna omemba",
  "privacy.private.long": "Samo vašim sledilcem",
  "privacy.private.short": "Sledilcem",
  "privacy.public.long": "Vsem, ki so ali niso na Mastodonu",
  "privacy.public.short": "Javno",
  "privacy.unlisted.additional": "Učinek je enak kot pri javni objavi, le da se ta ne bo prikazala v živih virih, med ključniki, raziskovanjem ali iskanjem, četudi ste to vključili na ravni računa.",
  "privacy.unlisted.short": "Tiho javno",
  "privacy_policy.last_updated": "Zadnja posodobitev {date}",
  "privacy_policy.title": "Pravilnik o zasebnosti",
  "recommended": "Priporočeno",
  "refresh": "Osveži",
  "regeneration_indicator.please_stand_by": "Prosimo, počakajte.",
  "regeneration_indicator.preparing_your_home_feed": "Pripravljamo vaš domači vir …",
  "relative_time.days": "{number} d",
  "relative_time.full.days": "{number, plural, one {pred # dnem} two {pred # dnevoma} few {pred # dnevi} other {pred # dnevi}}",
  "relative_time.full.hours": "{number, plural, one {pred # uro} two {pred # urama} few {pred # urami} other {pred # urami}}",
  "relative_time.full.just_now": "pravkar",
  "relative_time.full.minutes": "{number, plural, one {pred # minuto} two {pred # minutama} few {pred # minutami} other {pred # minutami}}",
  "relative_time.full.seconds": "{number, plural, one {pred # sekundo} two {pred # sekundama} few {pred # sekundami} other {pred # sekundami}}",
  "relative_time.hours": "{number} u",
  "relative_time.just_now": "zdaj",
  "relative_time.minutes": "{number} m",
  "relative_time.seconds": "{number} s",
  "relative_time.today": "danes",
  "remove_quote_hint.button_label": "Razumem",
  "reply_indicator.attachments": "{count, plural, one {# priloga} two {# prilogi} few {# priloge} other {# prilog}}",
  "reply_indicator.cancel": "Prekliči",
  "reply_indicator.poll": "Anketa",
  "report.block": "Blokiraj",
  "report.block_explanation": "Njihovih objav ne boste videli. Oni ne bodo videli vaših objav, niti vam ne morejo slediti. Lahko bodo ugotovili, da so blokirani.",
  "report.categories.legal": "Pravno obvestilo",
  "report.categories.other": "Drugo",
  "report.categories.spam": "Neželeno",
  "report.categories.violation": "Vsebina krši eno ali več pravil strežnika",
  "report.category.subtitle": "Izberite najustreznejši zadetek",
  "report.category.title": "Povejte nam, kaj se dogaja s to/tem {type}",
  "report.category.title_account": "profil",
  "report.category.title_status": "objava",
  "report.close": "Opravljeno",
  "report.comment.title": "Je še kaj, za kar menite, da bi morali vedeti?",
  "report.forward": "Posreduj k {target}",
  "report.forward_hint": "Račun je z drugega strežnika. Ali želite poslati anonimno kopijo prijave tudi na drugi strežnik?",
  "report.mute": "Utišaj",
  "report.mute_explanation": "Njihovih objav ne boste videli. Še vedno vam lahko sledijo in vidijo vaše objave, ne bodo pa vedeli, da so utišani.",
  "report.next": "Naprej",
  "report.placeholder": "Dodatni komentarji",
  "report.reasons.dislike": "Ni mi všeč",
  "report.reasons.dislike_description": "To ni tisto, kar želim videti",
  "report.reasons.legal": "To ni legalno",
  "report.reasons.legal_description": "Sem mnenja, da krši zakonodajo moje države ali države strežnika",
  "report.reasons.other": "Gre za nekaj drugega",
  "report.reasons.other_description": "Težava ne sodi v druge kategorije",
  "report.reasons.spam": "To je neželena vsebina",
  "report.reasons.spam_description": "Škodljive povezave, lažno prizadevanje ali ponavljajoči se odgovori",
  "report.reasons.violation": "Krši strežniška pravila",
  "report.reasons.violation_description": "Zavedate se, da krši določena pravila",
  "report.rules.subtitle": "Izberite vse, kar ustreza",
  "report.rules.title": "Katera pravila so kršena?",
  "report.statuses.subtitle": "Izberite vse, kar ustreza",
  "report.statuses.title": "Ali so kakšne objave, ki dokazujejo trditve iz te prijave?",
  "report.submit": "Pošlji",
  "report.target": "Prijavljate {target}",
  "report.thanks.take_action": "Tukaj so vaše možnosti za nadzor tistega, kar vidite na Mastodonu:",
  "report.thanks.take_action_actionable": "Medtem, ko to pregledujemo, lahko proti @{name} ukrepate:",
  "report.thanks.title": "Ali ne želite videti tega?",
  "report.thanks.title_actionable": "Hvala za prijavo, bomo preverili.",
  "report.unfollow": "Ne sledi več @{name}",
  "report.unfollow_explanation": "Temu računu sledite. Da ne boste več videli njegovih objav v svojem domačem viru, mu prenehajte slediti.",
  "report_notification.attached_statuses": "{count, plural, one {{count} objava pripeta} two {{count} objavi pripeti} few {{count} objave pripete} other {{count} objav pripetih}}",
  "report_notification.categories.legal": "Legalno",
  "report_notification.categories.legal_sentence": "nedovoljena vsebina",
  "report_notification.categories.other": "Drugo",
  "report_notification.categories.other_sentence": "drugo",
  "report_notification.categories.spam": "Neželeno",
  "report_notification.categories.spam_sentence": "neželeno",
  "report_notification.categories.violation": "Kršitev pravila",
  "report_notification.categories.violation_sentence": "kršitev pravila",
  "report_notification.open": "Odpri prijavo",
  "search.clear": "Počisti iskanje",
  "search.no_recent_searches": "Ni nedavnih iskanj",
  "search.placeholder": "Iskanje",
  "search.quick_action.account_search": "Profili, ki se ujemajo z {x}",
  "search.quick_action.go_to_account": "Pojdi na profil {x}",
  "search.quick_action.go_to_hashtag": "Pojdi na ključnik {x}",
  "search.quick_action.open_url": "Odpri URL v Mastodonu",
  "search.quick_action.status_search": "Objave, ki se ujemajo z {x}",
  "search.search_or_paste": "Iščite ali prilepite URL",
  "search_popout.full_text_search_disabled_message": "Ni dostopno na {domain}.",
  "search_popout.full_text_search_logged_out_message": "Na voljo le, če ste prijavljeni.",
  "search_popout.language_code": "Jezikovna koda ISO",
  "search_popout.options": "Možnosti iskanja",
  "search_popout.quick_actions": "Hitra dejanja",
  "search_popout.recent": "Nedavna iskanja",
  "search_popout.specific_date": "izbrani datum",
  "search_popout.user": "uporabnik",
  "search_results.accounts": "Profili",
  "search_results.all": "Vse",
  "search_results.hashtags": "Ključniki",
  "search_results.no_results": "Ni rezultatov.",
  "search_results.no_search_yet": "Pobrskajte med objavami, profili in ključniki.",
  "search_results.see_all": "Poglej vse",
  "search_results.statuses": "Objave",
  "search_results.title": "Zadetki za \"{q}\"",
  "server_banner.about_active_users": "Osebe, ki so uporabljale ta strežnik zadnjih 30 dni (dejavni uporabniki meseca)",
  "server_banner.active_users": "dejavnih uporabnikov",
  "server_banner.administered_by": "Upravlja:",
  "server_banner.is_one_of_many": "{domain} je en izmed mnogih neodvisnih strežnikov Mastodon, ki ga lahko uporabljate za sodelovanje v fediverzumu.",
  "server_banner.server_stats": "Statistika strežnika:",
  "sign_in_banner.create_account": "Ustvari račun",
  "sign_in_banner.follow_anyone": "Sledite komurkoli iz fediverzuma in vidite vse objave v časovnem vrstnem redu. Brez skritih algoritmov ter brez oglasov in vab za klikanje na vidiku.",
  "sign_in_banner.mastodon_is": "Mastodon je najboljši način, da ste na tekočem z dogajanjem.",
  "sign_in_banner.sign_in": "Prijava",
  "sign_in_banner.sso_redirect": "Prijavite ali registrirajte se",
  "status.admin_account": "Odpri vmesnik za moderiranje za @{name}",
  "status.admin_domain": "Odpri vmesnik za moderiranje za {domain}",
  "status.admin_status": "Odpri to objavo v vmesniku za moderiranje",
  "status.block": "Blokiraj @{name}",
  "status.bookmark": "Dodaj med zaznamke",
  "status.cancel_reblog_private": "Prekliči izpostavitev",
  "status.cannot_reblog": "Te objave ni mogoče izpostaviti",
  "status.contains_quote": "Vsebuje citat",
  "status.context.loading": "Nalaganje več odgovorov",
  "status.context.loading_error": "Novih odgovorov ni bilo možno naložiti",
  "status.context.loading_success": "Novi odgovori naloženi",
  "status.context.more_replies_found": "Najdenih več odgovorov",
  "status.context.retry": "Poskusi znova",
  "status.context.show": "Pokaži",
  "status.continued_thread": "Nadaljevanje niti",
  "status.copy": "Kopiraj povezavo do objave",
  "status.delete": "Izbriši",
  "status.delete.success": "Objava je izbrisana",
  "status.detailed_status": "Podroben pogled pogovora",
  "status.direct": "Zasebno omeni @{name}",
  "status.direct_indicator": "Zasebna omemba",
  "status.edit": "Uredi",
  "status.edited": "Zadnje urejanje {date}",
  "status.edited_x_times": "Urejeno {count, plural, one {#-krat} two {#-krat} few {#-krat} other {#-krat}}",
  "status.embed": "Pridobite kodo za vgradnjo",
  "status.favourite": "Priljubljen/a",
  "status.filter": "Filtriraj to objavo",
  "status.history.created": "{name}: ustvarjeno {date}",
  "status.history.edited": "{name}: urejeno {date}",
  "status.load_more": "Naloži več",
  "status.media.open": "Kliknite za odpiranje",
  "status.media.show": "Kliknite za prikaz",
  "status.media_hidden": "Predstavnosti so skrite",
  "status.mention": "Omeni @{name}",
  "status.more": "Več",
  "status.mute": "Utišaj @{name}",
  "status.mute_conversation": "Utišaj pogovor",
  "status.open": "Razširi to objavo",
  "status.pin": "Pripni na profil",
  "status.quote": "Citiraj",
  "status.quote.cancel": "Prekliči citat",
  "status.quote_error.blocked_account_hint.title": "Ta objava je skrita, ker ste blokirali up. @{name}.",
  "status.quote_error.blocked_domain_hint.title": "Ta objava je skrita, ker ste blokirali {domain}.",
  "status.quote_error.filtered": "Skrito zaradi enega od vaših filtrov",
  "status.quote_error.limited_account_hint.action": "Vseeno pokaži",
  "status.quote_error.limited_account_hint.title": "Ta račun so moderatorji {domain} skrili.",
  "status.quote_error.muted_account_hint.title": "Ta objava je skrita, ker ste utišali up. @{name}.",
  "status.quote_error.not_available": "Objava ni na voljo",
  "status.quote_error.revoked": "Avtor je umaknil objavo",
  "status.quote_followers_only": "Samo sledilci lahko citirajo to objavo",
  "status.quote_policy_change": "Spremenite, kdo lahko citira",
  "status.quote_private": "Zasebnih objav ni možno citirati",
  "status.quotes.empty": "Nihče še ni citiral te objave. Ko se bo to zgodilo, se bodo pojavile tukaj.",
  "status.quotes.local_other_disclaimer": "Citati, ki jih je avtor zavrnil, ne bodo prikazani.",
  "status.quotes_count": "{count, plural, one {{counter} citat} two {{counter} citata} few {{counter} citati} other {{counter} citatov}}",
  "status.read_more": "Preberi več",
  "status.reblog": "Izpostavi",
  "status.reblogged_by": "{name} je izpostavil/a",
  "status.reblogs.empty": "Nihče še ni izpostavil te objave. Ko se bo to zgodilo, se bodo pojavile tukaj.",
  "status.redraft": "Izbriši in preoblikuj",
  "status.remove_bookmark": "Odstrani zaznamek",
  "status.remove_favourite": "Odstrani iz priljubljenih",
  "status.remove_quote": "Odstrani",
  "status.replied_in_thread": "Odgovor iz niti",
  "status.replied_to": "Odgovoril/a {name}",
  "status.reply": "Odgovori",
  "status.replyAll": "Odgovori na nit",
  "status.report": "Prijavi @{name}",
  "status.sensitive_warning": "Občutljiva vsebina",
  "status.share": "Deli",
  "status.show_less_all": "Prikaži manj za vse",
  "status.show_more_all": "Pokaži več za vse",
  "status.show_original": "Pokaži izvirnik",
  "status.title.with_attachments": "{user} je objavil/a {attachmentCount, plural, one {{attachmentCount} priponko} two {{attachmentCount} priponki} few {{attachmentCount} priponke} other {{attachmentCount} priponk}}",
  "status.translate": "Prevedi",
  "status.translated_from_with": "Prevedeno iz {lang} s pomočjo {provider}",
  "status.uncached_media_warning": "Predogled ni na voljo",
  "status.unmute_conversation": "Odtišaj pogovor",
  "status.unpin": "Odpni iz profila",
  "subscribed_languages.lead": "Po spremembi bodo na vaši domači in seznamski časovnici prikazane objave samo v izbranih jezikih. Izberite brez, da boste prejemali objave v vseh jezikih.",
  "subscribed_languages.save": "Shrani spremembe",
  "subscribed_languages.target": "Spremeni naročene jezike za {target}",
  "tabs_bar.home": "Domov",
  "tabs_bar.menu": "Meni",
  "tabs_bar.notifications": "Obvestila",
  "tabs_bar.publish": "Nova objava",
  "tabs_bar.search": "Išči",
  "terms_of_service.effective_as_of": "Veljavno od {date}",
  "terms_of_service.title": "Pogoji uporabe",
  "terms_of_service.upcoming_changes_on": "Spremembe začnejo veljati {date}",
  "time_remaining.days": "{number, plural, one {preostaja # dan} two {preostajata # dneva} few {preostajajo # dnevi} other {preostaja # dni}}",
  "time_remaining.hours": "{number, plural, one {# ura} other {# ur}} je ostalo",
  "time_remaining.minutes": "{number, plural, one {# minuta} other {# minut}} je ostalo",
  "time_remaining.moments": "Preostali trenutki",
  "time_remaining.seconds": "{number, plural, one {# sekunda je preostala} two {# sekundi sta preostali} few {# sekunde so preostale} other {# sekund je preostalo}}",
  "trends.counter_by_accounts": "{count, plural, one {{count} oseba} two {{count} osebi} few {{count} osebe} other {{count} oseb}} v {days, plural, one {zadnjem {day} dnevu} two {zadnjih {days} dneh} few {zadnjih {days} dneh} other {zadnjih {days} dneh}}",
  "trends.trending_now": "Zdaj v trendu",
  "ui.beforeunload": "Vaš osnutek bo izgubljen, če zapustite Mastodona.",
  "units.short.billion": "{count} milijard",
  "units.short.million": "{count} mio.",
  "units.short.thousand": "{count} tisoč",
  "upload_area.title": "Za pošiljanje povlecite in spustite",
  "upload_button.label": "Dodajte slike, video ali zvočno datoteko",
  "upload_error.limit": "Omejitev prenosa datoteke je presežena.",
  "upload_error.poll": "Prenos datoteke z anketami ni dovoljen.",
  "upload_error.quote": "Prenos datoteke s citati ni dovoljen.",
  "upload_form.drag_and_drop.instructions": "Predstavnostno priponko lahko poberete tako, da pritisnete preslednico ali vnašalko. S puščicami na tipkovnici premikate priponko v posamezno smer. Priponko lahko odložite na novem položaju s ponovnim pritiskom na preslednico ali vnašalko ali pa dejanje prekličete s tipko ubežnica.",
  "upload_form.drag_and_drop.on_drag_cancel": "Premikanje priponke je preklicano. Predstavnostna priponka {item} je padla nazaj na prejšnje mesto.",
  "upload_form.drag_and_drop.on_drag_end": "Predstavnostna priponka {item} je padla nazaj.",
  "upload_form.drag_and_drop.on_drag_over": "Priponka {item} je bila premaknjena.",
  "upload_form.drag_and_drop.on_drag_start": "Pobrana priponka {item}.",
  "upload_form.edit": "Uredi",
  "upload_progress.label": "Pošiljanje ...",
  "upload_progress.processing": "Obdelovanje …",
  "username.taken": "To uporabniško ime je zasedeno. Poskusite z drugim.",
  "video.close": "Zapri video",
  "video.download": "Prenesi datoteko",
  "video.exit_fullscreen": "Izhod iz celozaslonskega načina",
  "video.expand": "Razširi video",
  "video.fullscreen": "Celozaslonski način",
  "video.hide": "Skrij video",
  "video.mute": "Utišaj",
  "video.pause": "Premor",
  "video.play": "Predvajaj",
  "video.skip_backward": "Preskoči nazaj",
  "video.skip_forward": "Preskoči naprej",
  "video.unmute": "Odtišaj",
  "video.volume_down": "Zmanjšaj glasnost",
  "video.volume_up": "Povečaj glasnost",
  "visibility_modal.button_title": "Določi vidnost",
  "visibility_modal.header": "Vidnost in interakcija",
  "visibility_modal.helper.privacy_editing": "Vidnosti ni moč spremeniti, ko je objava objavljena.",
  "visibility_modal.privacy_label": "Vidnost",
  "visibility_modal.quote_followers": "Samo sledilci",
  "visibility_modal.quote_label": "Kdo lahko citira",
  "visibility_modal.quote_nobody": "Samo jaz",
  "visibility_modal.quote_public": "Vsi",
  "visibility_modal.save": "Shrani"
}
